import type { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import { twMerge } from 'tailwind-merge';

export const IconPlayTvguide = ({ classProps }: PropsWithClassProps) => {
  const iconStyle = twMerge(
    'relative inline-block size-4 shrink-0 overflow-hidden rounded-full border border-current',
    classProps?.root,
  );
  return (
    <span className={iconStyle} aria-hidden="true">
      {/* biome-ignore lint/performance/noImgElement: Static 7x8 SVG, served directly without the site's custom image loader. */}
      <img src="/assets/icons/play-tvguide.svg" alt="" width={7} height={8} className="absolute top-[3px] left-[4px]" />
    </span>
  );
};
